import { useEffect, useState } from 'react'

import { IntroContainer } from 'components/intro-container'
import {
  Gradient,
  TitleContainer,
  Title,
  Subtitle,
} from 'components/intro-container/styled'
import backgroundL from './images/Background_L.webp'
import backgroundM from './images/Background_M.webp'
import backgroundS from './images/Background_S.webp'
import figureL from './images/Figure_L.webp'
import figureM from './images/Figure_M.webp'
import figureS from './images/Figure_S.webp'
import hand1L from './images/Hand1_L.webp'
import hand1M from './images/Hand1_M.webp'
import hand1S from './images/Hand1_S.webp'
import hand2L from './images/Hand2_L.webp'
import hand2M from './images/Hand2_M.webp'
import hand2S from './images/Hand2_S.webp'
import {
  AnimationContainer,
  Background,
  Hand1,
  Hand2,
  Person,
  Figure,
} from './styled'
import { useAppContext } from 'context/app-context'

export const Animation = () => {
  const { setLoading, isPageVisible } = useAppContext()
  const [loadedImages, setLoadedImages] = useState(0)

  const onLoadImages = (e: React.SyntheticEvent<HTMLImageElement>) => {
    setLoadedImages((loadedImages) => loadedImages + 1)
  }

  useEffect(() => {
    if (loadedImages === 4) {
      setLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadedImages])

  return (
    <IntroContainer>
      <AnimationContainer>
        <picture>
          <source
            srcSet={backgroundS}
            media="(max-width: 520px)"
            type="image/webp"
          />
          <source
            srcSet={backgroundM}
            media="(max-width: 1024px)"
            type="image/webp"
          />
          <Background src={backgroundL} alt="" onLoad={onLoadImages} />
        </picture>
        <Person $isPageVisible={isPageVisible}>
          <picture>
            <source
              srcSet={hand1S}
              media="(max-width: 520px)"
              type="image/webp"
            />
            <source
              srcSet={hand1M}
              media="(max-width: 1024px)"
              type="image/webp"
            />
            <Hand1
              $isPageVisible={isPageVisible}
              alt=""
              src={hand1L}
              onLoad={onLoadImages}
            />
          </picture>
          <picture>
            <source
              srcSet={figureS}
              media="(max-width: 520px)"
              type="image/webp"
            />
            <source
              srcSet={figureM}
              media="(max-width: 1024px)"
              type="image/webp"
            />
            <Figure
              src={figureL}
              alt=""
              onLoad={onLoadImages}
              $isPageVisible={isPageVisible}
            />
          </picture>
          <picture>
            <source
              srcSet={hand2S}
              media="(max-width: 520px)"
              type="image/webp"
            />
            <source
              srcSet={hand2M}
              media="(max-width: 1024px)"
              type="image/webp"
            />
            <Hand2
              $isPageVisible={isPageVisible}
              alt=""
              src={hand2L}
              onLoad={onLoadImages}
            />
          </picture>
        </Person>
      </AnimationContainer>
      <Gradient />
      <TitleContainer $hidden={isPageVisible}>
        <Title>Хизмат с рассвета и постоянные упреки</Title>
        <Subtitle>
          Как келин в Таджикистане страдают от психологического насилия
        </Subtitle>
      </TitleContainer>
    </IntroContainer>
  )
}
